import { render, staticRenderFns } from "./IndustrialDistribution.vue?vue&type=template&id=7570e452&scoped=true"
import script from "./IndustrialDistribution.vue?vue&type=script&lang=js"
export * from "./IndustrialDistribution.vue?vue&type=script&lang=js"
import style0 from "./IndustrialDistribution.vue?vue&type=style&index=0&id=7570e452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7570e452",
  null
  
)

export default component.exports